import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface ActionMenuItem {
  name: string;
  icon?: React.ReactNode;
  navigateUrl: string | ((id: string | number) => string);
  onClick?: () => void;
}

export interface ActionButtonProps {
  id: string | number;
  menuItems: ActionMenuItem[];
}

export const ActionButton: React.FC<ActionButtonProps> = ({ id, menuItems }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (item: ActionMenuItem) => {
    handleClose();
    
    if (item.onClick) {
      item.onClick();
    } else {
      const url = typeof item.navigateUrl === "function" 
        ? item.navigateUrl(id) 
        : item.navigateUrl;
      navigate(url);
    }
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-controls={open ? "action-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {menuItems.map((item, index) => (
          <MenuItem key={index} onClick={() => handleMenuItemClick(item)}>
            {item.icon && (
              <span style={{ marginRight: 8, display: "inline-flex", alignItems: "center" }}>
                {item.icon}
              </span>
            )}
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

